<script setup lang="ts">
import { useConfirm } from '@/shared/composables/useConfirm';
import ConfirmDialog from './ConfirmDialog.vue';

const { state, answer } = useConfirm();
</script>

<template>
  <ConfirmDialog
    :open="state.open"
    :title="state.title"
    :message="state.message"
    :variant="state.destructive ? 'destructive' : 'primary'"
    :confirm-label="state.confirmLabel || 'Confirm'"
    cancel-label="Cancel"
    @update:open="(v) => !v && answer(false)"
    @confirm="answer(true)"
    @cancel="answer(false)"
  />
</template>
